//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import { IContentLibraryAutocomplete } from '@apis/content-library/contentLibraryApiModel';
import { FilterOption } from '@components/media-filters/filterSectionModels';
import { isDefined } from '@utils/filterPredicates';

// Get first option by specified value
export const findOptionByValue = (
  options: FilterOption<string>[],
  value: string,
): FilterOption<string> | undefined => {
  return options.find((option) => option.value === value);
};

// Get first option by specified label
export const findOptionByLabel = (
  options: FilterOption<string>[],
  label: IContentLibraryAutocomplete,
): FilterOption<string> | undefined => {
  return options.find((option) => option.value === label.value);
};

// Get first label by specified option
export const findLabelByOption = (
  labels: IContentLibraryAutocomplete[],
  option: FilterOption<string>,
): IContentLibraryAutocomplete | undefined => {
  return labels.find((label) => option.value === label.value);
};

// Get all selected options and options that match labels
export const filterSelectedLabels = (
  options: FilterOption<string>[],
  labels: IContentLibraryAutocomplete[] = [],
): FilterOption<string>[] => {
  return options.filter(
    (option) =>
      option.isSelected || isDefined(findLabelByOption(labels, option)),
  );
};

// Map content library label to filter option
export const mapLabelToOption = (
  label: IContentLibraryAutocomplete,
): FilterOption<string> => {
  return {
    ...label,
    isSelected: false,
    label: label.value,
    value: label.value,
  };
};
